// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"467": "aba2c31dc627966d","936": "e65b58e906880db9","982": "2399986290290e53","983": "8dd7c99cb4018dd0",}[chunkId] + ".css"
}